import React from "react";
import "./AtualizeSeusDados.css";
import {
  Section,
  Heading,
  Paragraph,
  Button,
  ImageWithDecor,
} from "./UIComponents";

import fotoDestaque from "../../assets/img/atualize-seus-dados.webp";

const AtualizeSeusDados: React.FC = () => {
  return (
    <Section className="atualize-content">
      <div className="atualize-text-area">
        <Heading level={2}>
          Atualize
          <br />
          seus dados
        </Heading>
        <Paragraph>
          Se você é participante assistido ou pensionista, não
          <br />
          perca tempo. É fácil e muito importante para você!
        </Paragraph>
        <Button
          href="https://participante.forluz.org.br/login"
          label="Atualizar agora"
        />
      </div>
      <ImageWithDecor src={fotoDestaque} alt="Atualize seus dados" />
    </Section>
  );
};

export default AtualizeSeusDados;
